module.exports = __webpack_public_path__ + "static/Coffee-4c7186eb1b8f7c3c9490a4aa9934cfc6.png";